import React, { useState, useEffect, useRef } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import Swal from "sweetalert2";
import axios from "axios";
import { baseurl } from "../../Baseurl";

const BlogAdd = () => {
  const [categories, setCategories] = useState([]);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const editorRef = useRef(null);
  const editorInstance = useRef(null);

  const [formData, setFormData] = useState({
    category_id: "",
    title: "",
    slug: "",
    content: "",
    author_name: "",
    is_published: false,
    title_tag: "",
    meta_description: "",
    meta_keywords: "",
    schema_markup: "",
    alt_img: "",
  });

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${baseurl}GetAllBlogCategories`);
        setCategories(res.data.categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
        Swal.fire("Error", "Failed to load categories", "error");
      }
    };
    fetchCategories();
  }, []);













  let isEditorInitialized = false; 

  
// Initialize CKEditor only once
useEffect(() => {
  // Check if CKEDITOR is loaded and the ref is available
  if (!window.CKEDITOR || !editorRef.current) return;

  // Check if an instance already exists on the DOM element
  // This is a common way to prevent re-initialization outside of Strict Mode.
  // Although we will add cleanup, this is still a good check.
  if (editorRef.current.__ckInstance) return;

  let editorInstanceCleanup = null; // Variable to hold the instance for cleanup

  const initEditor = async () => {
    // Check again to avoid race conditions
    if (editorRef.current.__ckInstance) return;

    try {
        const editor = await window.CKEDITOR.ClassicEditor.create(editorRef.current, {
            toolbar: {
              items: [
                "undo", "redo", "|", "heading", "|",
                "bold", "italic", "underline", "|",
                "fontColor", "fontBackgroundColor", "|",
                "link", "|",
                "bulletedList", "numberedList", "|",
                "insertTable", "|",
                "sourceEditing"
              ],
            },
            heading: {
              options: [
                { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
                { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
                { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
                { model: "heading3", view: "h3", title: "Heading 3", class: "ck-heading_heading3" },
              ],
            },
            removePlugins: [
              "CKBox", "CKFinder", "EasyImage",
              "RealTimeCollaborativeComments",
              "RealTimeCollaborativeTrackChanges",
              "RealTimeCollaborativeRevisionHistory",
              "PresenceList", "Comments", "TrackChanges",
              "TrackChangesData", "RevisionHistory",
              "Pagination", "WProofreader"
            ],
          });

        // Store the instance in both refs and for cleanup
        editorInstance.current = editor;
        editorRef.current.__ckInstance = editor;
        editorInstanceCleanup = editor; // Set instance for cleanup

        // Update formData.content on change
        editor.model.document.on("change:data", () => {
          setFormData(prev => ({ ...prev, content: editor.getData() }));
        });

    } catch (error) {
        console.error("Error initializing CKEditor:", error);
    }
  };

  initEditor();

  // Cleanup function: This runs on unmount (or the first 'unmount' in Strict Mode)
  return () => {
    if (editorInstanceCleanup) {
        // Destroy the editor instance
        editorInstanceCleanup.destroy()
            .catch(error => console.error("Error destroying CKEditor:", error));
        
        // Remove the custom property from the DOM element
        editorRef.current.__ckInstance = null; 
    }
    // Also clear the general ref
    editorInstance.current = null;
  };
}, []); // Runs only once on mount and cleanup on unmount


























  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const slugify = (text) =>
      text.toString().toLowerCase().trim()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "")
        .replace(/--+/g, "-");

    setFormData(prev => {
      const updatedData = { ...prev, [name]: type === "checkbox" ? checked : value };
      if (name === "title") updatedData.slug = slugify(value);
      return updatedData;
    });
  };

  const handleFileChange = (e) => setThumbnailFile(e.target.files[0]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      Object.entries(formData).forEach(([key, value]) => data.append(key, value));
      if (thumbnailFile) data.append("thumbnail", thumbnailFile);

      const res = await axios.post(`${baseurl}AddBlog`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.status === 201) {
        Swal.fire("Success!", "Blog added successfully.", "success");
        setFormData({
          category_id: "",
          title: "",
          slug: "",
          content: "",
          author_name: "",
          is_published: false,
          title_tag: "",
          meta_description: "",
          meta_keywords: "",
          schema_markup: "",
          alt_img: "",
        });
        setThumbnailFile(null);
        if (editorInstance.current) editorInstance.current.setData(""); // Clear editor
      }
    } catch (error) {
      console.error("Error adding blog:", error);
      Swal.fire("Error!", "Failed to add blog.", "error");
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container card">
          <h4 className="text-start mb-4">Add Blog</h4>
          <form onSubmit={handleSubmit}>
            {/* Category */}
            <div className="mb-3 text-start">
              <label className="form-label">Blog Category</label>
              <select
                className="form-control"
                name="category_id"
                value={formData.category_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Blog Category</option>
                {categories.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.name}</option>
                ))}
              </select>
            </div>

            {/* Title */}
            <div className="mb-3 text-start">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                name="title"
                placeholder="Enter Title here"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>

            {/* Slug */}
            <div className="mb-3 text-start">
              <label className="form-label">Slug</label>
              <input
                type="text"
                className="form-control"
                name="slug"
                placeholder="Enter slug here"
                value={formData.slug}
                onChange={handleChange}
                required
              />
            </div>

            {/* CKEditor */}
            <div className="mb-3 text-start">
              <label className="form-label">Content</label>
              <div ref={editorRef} style={{ minHeight: "200px", border: "1px solid #ccc" }}></div>
            </div>

            {/* Author */}
            <div className="mb-3 text-start">
              <label className="form-label">Author Name</label>
              <input
                type="text"
                className="form-control"
                name="author_name"
                placeholder="Enter Author here"
                value={formData.author_name}
                onChange={handleChange}
                required
              />
            </div>

            {/* Thumbnail */}
            <div className="mb-3 text-start">
              <label className="form-label">Thumbnail Image</label>
              <input type="file" className="form-control" accept="image/*" onChange={handleFileChange} />
            </div>

            {/* Alt Text */}
            <div className="mb-3 text-start">
              <label className="form-label">Alt Text</label>
              <input
                type="text"
                className="form-control"
                name="alt_img"
                placeholder="Enter Alt text"
                value={formData.alt_img}
                onChange={handleChange}
                required
              />
            </div>

            {/* SEO Fields */}
            <h3 className="text-start">SEO Parameters</h3>
            <div className="mb-3 text-start">
              <label className="form-label">Blog Title</label>
              <input
                type="text"
                className="form-control"
                name="title_tag"
                placeholder="Enter Title here"
                value={formData.title_tag}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3 text-start">
              <label className="form-label">Meta Description</label>
              <input
                type="text"
                className="form-control"
                name="meta_description"
                placeholder="Enter Meta Description"
                value={formData.meta_description}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3 text-start">
              <label className="form-label">Meta Keyword</label>
              <input
                type="text"
                className="form-control"
                name="meta_keywords"
                placeholder="Enter Meta Keyword"
                value={formData.meta_keywords}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3 text-start">
              <label className="form-label">Meta Schema</label>
              <input
                type="text"
                className="form-control"
                name="schema_markup"
                placeholder="Enter Meta Schema"
                value={formData.schema_markup}
                onChange={handleChange}
                required
              />
            </div>

            {/* Publish */}
            <div className="form-check mb-3 text-start">
              <input
                className="form-check-input"
                type="checkbox"
                name="is_published"
                checked={formData.is_published}
                onChange={handleChange}
              />
              <label className="form-check-label">Publish Blog</label>
            </div>

            <div className="text-end">
              <button type="submit" className="btn submitbtnn">Submit Blog</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BlogAdd;
